(() => {
  const rootUrl = window.Shopify?.routes?.root || '/';

  async function removePersonalization(button) {
    const key = button.dataset.lineKey;
    const propertyToRemove = button.dataset.arquatiRemovePersonalization;
    if (!key || !propertyToRemove) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const cartResponse = await fetch(`${rootUrl}cart.js`, { credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error('Impossibile leggere il carrello');
      const cart = await cartResponse.json();
      const item = cart.items.find((line) => line.key === key);
      if (!item) throw new Error('Articolo non trovato nel carrello');

      const properties = { ...(item.properties || {}) };
      delete properties[propertyToRemove];

      const selected = [];
      if (properties.Iniziali) selected.push('Iniziali in oro');
      if (properties.Immagine) selected.push('Immagine personalizzata');
      if (properties.Frase) selected.push('Frase personalizzata');
      if (selected.length) properties.Personalizzazione = selected.join(' + ');
      else delete properties.Personalizzazione;

      const changeResponse = await fetch(`${rootUrl}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: item.quantity, properties }),
      });
      if (!changeResponse.ok) throw new Error('Impossibile aggiornare la personalizzazione');

      window.location.reload();
    } catch (error) {
      console.error('[Arquati cart personalization]', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.alert('Non è stato possibile rimuovere la personalizzazione. Riprova.');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-arquati-remove-personalization]');
    if (!button) return;
    event.preventDefault();
    removePersonalization(button);
  });
})();
